<template>
    <div id="ImportTotal">
        
        <div class="num">
            <span class="">{{ formatNumber(data.importValue) }}</span>
            <span class="text-lg">万元</span>
        </div>
        <div class="title">进口总额</div>
        <img class="m-auto" src="@/assets/img/Group219.png" alt="">
    </div>
</template>

<script>
    import {
        formatNumber
    } from "@/utils/tools";

export default {
    name: "",
    components: {
    },
    props: {
           data: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {

            dataList: []
        };
    },
    watch: {},
    computed: {},
    methods: {
        formatNumber,
        async init() {
            //综试区发展指数-中下
            try {
                const res = await cmsSysCloudlsdDevelopIndex()
                this.dataList = res.data
            } catch (err) {
                this.$message.error("数据加载失败")
            }

        }
    },
    created() { },
    async mounted() {
    }
}
</script>
<style lang="scss" scoped>
#ImportTotal {
    text-align: center;
    position: relative;

    .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #9e9a9a;
        line-height: 24px;
        font-style: normal;
        text-transform: none;
        position: absolute;
        top: 85px;
        width: 100%;
    }

    .num {
        width: 100%;
        font-family: D-DIN-PRO, D-DIN-PRO;
        font-weight: 800;
        font-size: 36px;
        line-height: 36px;
        letter-spacing: 5px;
        text-shadow: 0px 0px 16px rgba(61, 255, 255, 0.5);
        font-style: normal;
        text-transform: none;
        position: absolute;
        top: 25px;
        color: #3DFFFF;

        background: linear-gradient(90deg, #55FFF5, #DAFFFD);
        /* 渐变色 */
        -webkit-background-clip: text;
        /* 用文字形状裁剪背景 */
        -webkit-text-fill-color: transparent;
        /* 让文字填充透明 */
    }
}
</style>